import { render, staticRenderFns } from "./PaymentResponsibilityEdit.vue?vue&type=template&id=f73a0dd8&"
import script from "./PaymentResponsibilityEdit.vue?vue&type=script&lang=js&"
export * from "./PaymentResponsibilityEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports